import Templates from "../templates";
import AboutPage from "../organisms/aboutPage";
import { useEffect } from "react";
const About = () => {
  return (
   <Templates>
     <AboutPage/>
   </Templates>
  );
};

export default About;
